import { EntityStatus, StorylineSettings, YammerState, getStatus } from '../../state/types';

type GetStorylineSettings = (state: YammerState) => StorylineSettings | undefined;
export const getStorylineSettings: GetStorylineSettings = (state: YammerState) => state.storylineSettings.fulfilled;

type GetStorylineSettingsStatus = (state: YammerState) => EntityStatus;
export const getStorylineSettingsStatus: GetStorylineSettingsStatus = (state) => getStatus(state.storylineSettings);
